import { createFileRoute } from "@tanstack/react-router";
import { ogImageMeta } from "@/lib/seo/og-image";
import { PrAgencyPersonaPage } from "@/components/site/PrAgencyPersonaPage";
import { PR_AGENCY_META_DESCRIPTION } from "@/content/meta/PrAgencyPersonaPage";

import { pageSchemas } from "@/lib/seo/page-schema";
export const Route = createFileRoute("/who-we-help/pr-agency")({
  head: () => ({
    meta: [
      { title: "Media Intelligence for PR Agencies | Perceptica" },
      { name: "description", content: PR_AGENCY_META_DESCRIPTION },
      { property: "og:title", content: "Media Intelligence for PR Agencies | Perceptica" },
      { property: "og:description", content: PR_AGENCY_META_DESCRIPTION },
      { name: "twitter:title", content: "Media Intelligence for PR Agencies | Perceptica" },
      { name: "twitter:description", content: PR_AGENCY_META_DESCRIPTION },

      { name: "twitter:card", content: "summary_large_image" },
      { property: "og:url", content: "https://perceptica.com/who-we-help/pr-agency" },
      ...ogImageMeta("en", "/who-we-help/pr-agency"),
      { property: "og:type", content: "website" },
    ],
  
    scripts: pageSchemas({ locale: "en", path: "/who-we-help/pr-agency" }),
  }),
  component: PrAgencyPersonaPage,
});
